export function sanitizePathname(pathname) {
  let sanitized = pathname.replace(/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/g, '{uuid}');
  sanitized = sanitized.replace(/\/[a-z]{2}-[A-Z]{2}/, '/{locale}');
  return sanitized;
}
